export default __webpack_public_path__ + "static/1750-8e7f184cfbdecf2dee2714b38e70ce22.gif";